<template>
    <v-content>
        <v-container fluid>
            <h1>Layout Por defecto ok</h1>
            <slot></slot>
        </v-container>
    </v-content>       
</template>
<script>
    // import Header from '@/layouts/header_administrativo.vue';
    // bimport MenuLateral from '@/layouts/menu_lateral.vue';
    export default {
       name: 'Default',
   }
</script>